import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { finalize } from "rxjs/operators";
import { ApiService } from "../../../services/api.service";
var SendEmailModalComponent = (function () {
    function SendEmailModalComponent(activeModal, apiService) {
        this.activeModal = activeModal;
        this.apiService = apiService;
    }
    SendEmailModalComponent.prototype.ngOnInit = function () {
        this.email = this.modalData.email_data.join(', ');
        this.brokerEmail = this.modalData.cc_email_data.join(', ');
    };
    SendEmailModalComponent.prototype.sendMail = function () {
        var _this = this;
        this.isSending = true;
        var data = {
            id: this.modalData.id,
            customer_broker_batch_zip_id: this.modalData.customer_broker_batch_zip_id,
            email: this.email,
            broker_email: this.brokerEmail,
            action_log_address: 'EMAIL_DASHBOARD',
        };
        this.apiService.resend_via_email_dashboard(data)
            .pipe(finalize(function () {
            _this.isSending = false;
        }))
            .subscribe(function (res) {
            _this.resMessage = res.message;
            _this.isSuccess = true;
        }, function (err) {
            _this.resMessage = err.error;
            _this.isSuccess = false;
        });
    };
    SendEmailModalComponent.prototype.sniff = function (action, target) {
        var data = {
            action: action,
            address: 'EMAIL_DASHBOARD',
            target: target
        };
        this.apiService.sniff(data).subscribe();
    };
    return SendEmailModalComponent;
}());
export { SendEmailModalComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/email-dashboard/sendEmailModal/send-email-modal.component.ts.pre-build-optimizer.js